import React from 'react'
import clsx from 'clsx'

import Tooltip from '../Tooltip'

import { getCountryData } from '../../../utilities/phoneNumber'

const PhoneFlag = ({ value, className = undefined, ...props }) => {
  const countryData = React.useMemo(() => getCountryData(value), [value])

  return (
    <Tooltip title={`(${countryData.prefix}) ${countryData.country}`} arrow>
      <span className={clsx('fp', countryData.flag, className)} {...props} />
    </Tooltip>
  )
}

export default PhoneFlag
